module.exports = __webpack_public_path__ + "media/images/sandbox/promo_opt-bdd7149833758e0c973da5b1e8963504.png";